var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCup2Updated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 23,
    viewBox: "0 0 28 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95579 23L5.21479 20.5357L11.3418 17.25L11.6871 13.9643L1.89947 4.92857L2.24481 1.64286H7.2005L7.37317 0H14.8067H22.2403L22.0676 1.64286H27.0233L26.6779 4.92857L14.9909 13.9643L14.6456 17.25L20.0819 20.5357L19.8229 23H12.3893H4.95579ZM7.85378 3.28571H4.54999L4.46365 4.10714L7.50844 6.57143L7.85378 3.28571ZM21.069 3.28571H24.3728L24.2864 4.10714L20.7236 6.57143L21.069 3.28571Z",
    fill: "#D9D7CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4277 11.3123L11.6108 9.55192C11.7235 8.4957 12.1037 8.01689 13.0613 7.05925L14.0331 6.10162C14.5823 5.55238 14.7372 5.24256 14.8076 4.45392L14.8921 3.66528C14.9485 3.10196 14.6527 2.94705 14.3288 2.94705C13.9908 2.94705 13.7092 3.10196 13.6528 3.6512L13.5261 4.89049L12.0615 4.89049L12.2023 3.55262C12.329 2.31332 13.0754 1.65143 14.4274 1.65143C15.9624 1.65143 16.6102 2.39782 16.4553 3.80611L16.3567 4.73558C16.2441 5.73546 16.0047 6.15795 15.0893 7.07333L13.9767 8.15771C13.5261 8.60837 13.2022 8.93227 13.1318 9.60825L13.0895 10.0026L15.7371 10.0026L15.5963 11.3123L11.4277 11.3123Z",
    fill: "#161C31"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup2Updated);
export default __webpack_public_path__ + "static/media/cup-2-updated.ddee510bb372291a2a1d8477986a74e3.svg";
export { ForwardRef as ReactComponent };